import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import EventsScreen from './events';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import LunchSpecial from './lunchspecial';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [desserts, setdesserts] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showLunchSpecial, setShowLunchSpecial] = useState(false);
    const [Beverages, setBeverages] = useState(false);
   

    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };



    

    const Item = ({ item }) => {
        const isSelected = dishs && dishs.id === item.id;

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: 72,
                    position: 'relative',
                    cursor: 'pointer',
                    backgroundImage: `url(${require('./assets/BOTON1.png')})`,
                    backgroundPosition: 'center',
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    marginBottom: 8,
                    opacity: isSelected ? 1 : 0.95,
                }}
                onClick={() => {
                    if (item.id === 767) {
                        setShowDrinks(true);
                    } else {
                        setShowListProduct(true);
                        setdishs(item);
                    }
                }}
            >
                <p
                    style={{
                        color: '#cbbf9d',
                        fontSize: 30,
                       
                        letterSpacing: 1,
                        textAlign: 'center',
                        fontFamily: 'Noodle',
                        textTransform: 'uppercase',
                        margin: 0,
                        maxWidth: '80%',
                    }}
                >
                    {item.name}
                </p>
            </div>
        );
    };


         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 725) {
                setdesserts(item);
            }
            if (item.id === 628) {
                setBeverages(item);
            }
        });
    }, [menus]);


    const GoBeverages = () => {
        setShowListProduct(true);
        setdishs(Beverages);
    }


    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
          
          
           setShowLunchSpecial(false)
          
            setshowCategories(false)
            setShowDetailProduct(false)
            setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
          
           
           setShowLunchSpecial(false)
          
            setshowCategories(false)
          setShowDetailProduct(false)
           setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)
         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
                setShowListProduct(true)
                setdishs(Beverages)
        }} showBack={false} showCocktails={ GoBeverages} showEvents={ setShowEvents} showImageTop={true} setShowSpecials={setShowSpecials}>
                <div>
                    

                    <div style={{ width: '100%', position: 'relative', zIndex: 900, marginTop: -20, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 390,
                            height: 180,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: -10,
                                
                            marginLeft: 20,
                            
                            
                        }}
                        src={require('./assets/logo.png')}
                        />
{/* 
                        <div
                            onClick={() => {
                              setShowLunchSpecial(true);
                            }}
                            style={{
                             
                            width: 220,
                            height: 60,
                            justifyContent: 'center',
                            objectFit: 'contain',
                           
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'absolute',
                            right: -20,
                                top: 40,
                            zIndex: 2222

                            
                        }}>
                            <img
                            
                        style={{
                            width: 220,
                            height: 60,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            
                        }}
                        src={require('./assets/boton-lunch-special.png')}
                        />
                        </div> */}
                        
                       
                    </div>
                    
                    <div style={{
                     display: 'flex', width: '100%',
                        position: 'relative', zIndex: 100, paddingInline: 20,
                        boxSizing: 'border-box',
                        gap: 10,
                        marginTop: -25,
                    }}>
                       
                   
                    <div style={{ width: '33%'}}>
                            <img
                           
                            src={require('./assets/BANNER1.png')}
                            loop autoPlay={true} muted 
                            style={{
                                
                                width: '100%',
                                height: 486,
                                objectFit: 'contain',
                                
                                borderRadius: 14,
                                alignSelf: 'self-start',
                               
                               
                            }}
                        />

                        </div>
                        
                        <div style={{ width: '33%'}}>
                            <img
                           
                            src={require('./assets/BANNER2.png')}
                            loop autoPlay={true} muted 
                            style={{
                               
                                width: '100%',
                                height: 235,
                                objectFit: 'contain',
                                borderRadius: 14,
                                alignSelf: 'self-start',
                               
                            }}
                            />
                            
                            <img
                           
                            src={require('./assets/BANNER3.png')}
                            loop autoPlay={true} muted 
                            style={{
                                marginTop: 10,
                                width: '100%',
                               height: 235,
                                objectFit: 'contain',
                                
                                borderRadius: 14,
                                alignSelf: 'self-start',
                               
                               
                            }}
                        />

                    </div>

                    <div style={{ width: '33%' }} >
                          
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                gap: 10,
                                height: 480,
                                overflowY: 'auto',
                                paddingRight: 0,
                                    boxSizing: 'border-box',
                                marginTop: 5
                            }}
                        >
                            {menus.map((item, key) => {
                               if (![768, 726, 769, 770].includes(item.id)) {
                                    return <Item item={item} key={key} />;
                                }
                            })}
                        </div>
                    </div>

                    
                </div>
               
            </div>

            <div
                    onClick={() => {
                       // setShowListProduct(true)
                        //setdishs(desserts)
                        //  setShowDetailProduct(true)
                 //   setDataDish({ dish: tomahawk, alldish: steak, currentDish: tomahawk })
               }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                
                    boxSizing: 'border-box',
                   
                    }}>
                    <video
                        loop autoPlay={true} muted 
                        onContextMenu={(e) => e.preventDefault()}
                        //src={require('./assets/bannerinferior.png')}
                        src={require('./assets/bannerh.mp4')}
                    style={{
                        width: '95%',
                        height: 258,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -12,
                         pointerEvents: 'none',
                       
                        
                        
                    }}
                    />
                {/* <img
                    src={require('./assets/banner.png')}
                    style={{
                        width: '100%',
                        height: 174,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -10,
                        marginLeft: 5
                        
                    }}
                    /> */}
                  
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}

                {showLunchSpecial && <LunchSpecial setShowHappy={setShowLunchSpecial} />}
                
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;